/*
 * shop-system.js — поведение страницы магазина.
 *
 * Две вещи:
 *  1) статус и таблица часов — раз в минуту по Asia/Jerusalem (включая DST).
 *     Регулярная неделя + исключения по ISO-дате из shop-метафилда.
 *     Закешированная страница возвращается к обычным часам после праздника.
 *  2) вкладки «как добраться»: обе панели приходят видимыми, скрипт прячет
 *     неактивную — без JS страница остаётся читаемой.
 *
 * Инициализация идемпотентна: элементы помечаются data-shop-ready.
 */

(function () {
  if (window.shopSystem) return;
  window.shopSystem = true;

  var TICK_MS = 60000;
  var storeClock = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  });

  // Calendar arithmetic uses UTC dates; wall-clock time comes from Jerusalem.
  function calendarNow() {
    var parts = {};
    storeClock.formatToParts(new Date()).forEach(function (part) { parts[part.type] = part.value; });
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      minute: +parts.hour * 60 + +parts.minute };
  }

  function dateAt(date, offset) {
    return new Date(date.getTime() + offset * 86400000);
  }

  function dateKey(date) { return date.toISOString().slice(0, 10); }

  function hoursAt(config, date) {
    var key = dateKey(date);
    var slot = Object.prototype.hasOwnProperty.call(config.exceptions || {}, key) ?
      config.exceptions[key] : config.schedule[date.getUTCDay()];
    return String(slot || 'closed').split(',').map(function (interval) {
      var m = /^(\d{2}):(\d{2})-(\d{2}):(\d{2})$/.exec(interval);
      if (!m || +m[1] > 23 || +m[3] > 23 || +m[2] > 59 || +m[4] > 59) return null;
      var range = [+m[1] * 60 + +m[2], +m[3] * 60 + +m[4]];
      return range[0] < range[1] ? range : null;
    }).filter(Boolean);
  }

  /* ---------- Часы работы ---------- */

  function formatTime(minutes) {
    var hh = Math.floor(minutes / 60);
    var mm = minutes % 60;
    return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm);
  }

  function fill(template, values) {
    return Object.keys(values).reduce(function (text, token) {
      return text.split('[' + token + ']').join(values[token]);
    }, template || '');
  }

  function readConfig(root) {
    var node = root.querySelector('[data-shop-hours-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateHours(root) {
    var config = root.shopHoursConfig;
    if (!config) return;

    var now = calendarNow();
    var day = now.date.getUTCDay();
    var minute = now.minute;
    var today = hoursAt(config, now.date);
    var active = today.find(function (range) { return minute >= range[0] && minute < range[1]; });
    var isOpen = !!active;
    var note = '';
    if (active) {
      note = fill(config.labels.today, { open: formatTime(active[0]), close: formatTime(active[1]) });
    } else {
      for (var i = 0; i <= 31; i++) {
        var probeDate = dateAt(now.date, i);
        var probe = hoursAt(config, probeDate).find(function (range) { return i > 0 || range[0] > minute; });
        if (!probe) continue;
        if (i === 0) {
          note = fill(config.labels.opensToday, { time: formatTime(probe[0]) });
        } else if (i === 1) {
          note = fill(config.labels.opensTomorrow, { time: formatTime(probe[0]) });
        } else {
          var name = (config.labels.days || [])[probeDate.getUTCDay()] || '';
          if (i >= 7) name += ' ' + dateKey(probeDate).slice(8) + '.' + dateKey(probeDate).slice(5, 7);
          note = fill(config.labels.opensWeekday, { time: formatTime(probe[0]), day: name });
        }
        break;
      }
    }

    var label = root.querySelector('[data-shop-hours-label]');
    var dot = root.querySelector('[data-shop-hours-dot]');
    var noteNode = root.querySelector('[data-shop-hours-note]');

    if (label) label.textContent = isOpen ? config.labels.open : config.labels.closed;
    if (dot) dot.classList.toggle('shop-hours__dot--closed', !isOpen);
    if (noteNode) noteNode.textContent = note;

    Array.prototype.forEach.call(root.querySelectorAll('[data-shop-hours-day]'), function (row) {
      var rowDay = Number(row.getAttribute('data-shop-hours-day'));
      var rowDate = dateAt(now.date, rowDay - day);
      var rowHours = hoursAt(config, rowDate);
      var exception = (config.exceptions || {})[dateKey(rowDate)];
      row.classList.toggle('shop-hours__row--today', rowDay === day);
      row.classList.toggle('shop-hours__row--closed', !rowHours.length);
      var time = row.querySelector('[data-shop-hours-time]');
      var date = row.querySelector('[data-shop-hours-date]');
      if (time) time.textContent = !rowHours.length ? config.labels.closedDay :
        rowHours.map(function (range) { return formatTime(range[0]) + ' — ' + formatTime(range[1]); }).join(', ');
      if (date) date.textContent = exception ? ' · ' + dateKey(rowDate).slice(8) + '.' + dateKey(rowDate).slice(5, 7) : '';
    });
  }

  function initHours(root) {
    if (root.hasAttribute('data-shop-ready')) return;
    root.setAttribute('data-shop-ready', '');
    root.shopHoursConfig = readConfig(root);
    updateHours(root);
  }

  function expireSpecialDates() {
    var today = dateKey(calendarNow().date);
    document.querySelectorAll('[data-hours-special-date]').forEach(function (row) {
      row.hidden = row.getAttribute('data-hours-special-date') < today;
    });
    document.querySelectorAll('[data-hours-special-heading]').forEach(function (heading) {
      heading.hidden = !heading.parentElement.querySelector('[data-hours-special-date]:not([hidden])');
    });
  }

  function tick() {
    expireSpecialDates();
    Array.prototype.forEach.call(document.querySelectorAll('[data-shop-hours]'), updateHours);
  }

  /* ---------- Вкладки маршрута ---------- */

  function initTabs(tablist) {
    if (tablist.hasAttribute('data-shop-ready')) return;
    tablist.setAttribute('data-shop-ready', '');

    var scope = tablist.closest('section') || document;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[data-shop-tab]'));
    if (!tabs.length) return;

    function select(name) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-shop-tab') === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      Array.prototype.forEach.call(scope.querySelectorAll('[data-shop-panel]'), function (panel) {
        panel.hidden = panel.getAttribute('data-shop-panel') !== name;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-shop-tab'));
      });
    });

    var initial = tabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    }) || tabs[0];
    select(initial.getAttribute('data-shop-tab'));
  }

  /* ---------- Попап галереи ---------- */

  /*
   * Сам попап — штатный <modal-dialog> темы: открытие, focus trap, Escape и
   * блокировка прокрутки уже в нём. Здесь только выбор кадра и листание.
   */
  function showItem(modal, index) {
    var items = modal.querySelectorAll('[data-shop-lightbox-item]');
    if (!items.length) return;

    var total = items.length;
    var next = ((index % total) + total) % total;
    modal.shopLightboxIndex = next;

    Array.prototype.forEach.call(items, function (item) {
      item.hidden = parseInt(item.getAttribute('data-shop-lightbox-item'), 10) !== next;
    });

    /* Показанный слайд только сейчас начал грузить свой кадр: до load
       показываем spinner, иначе на его месте зияет тёмный прямоугольник. */
    if (window.DSPopupMedia) window.DSPopupMedia.track(items[next]);
  }

  function initLightbox(modal) {
    if (modal.hasAttribute('data-shop-ready')) return;
    modal.setAttribute('data-shop-ready', '');

    var prev = modal.querySelector('[data-shop-lightbox-prev]');
    var next = modal.querySelector('[data-shop-lightbox-next]');

    if (prev) {
      prev.addEventListener('click', function () {
        showItem(modal, (modal.shopLightboxIndex || 0) - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showItem(modal, (modal.shopLightboxIndex || 0) + 1);
      });
    }

    modal.addEventListener('keyup', function (event) {
      if (event.code === 'ArrowLeft') showItem(modal, (modal.shopLightboxIndex || 0) - 1);
      if (event.code === 'ArrowRight') showItem(modal, (modal.shopLightboxIndex || 0) + 1);
    });

    /*
     * ModalDialog закрывается по клику строго в себя, но диалог растянут на
     * весь экран и перехватывает фон. Поэтому закрываем сами: клик мимо
     * картинки и кнопок — это клик по фону.
     */
    var dialog = modal.querySelector('.shop-lightbox__dialog');
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.classList.contains('shop-lightbox__stage')) {
          modal.hide();
        }
      });
    }
  }

  function initLightboxOpener(button) {
    if (button.hasAttribute('data-shop-ready')) return;
    button.setAttribute('data-shop-ready', '');

    button.addEventListener('click', function () {
      var modal = document.querySelector(button.getAttribute('data-shop-lightbox-target'));
      /* Без загруженного global.js кнопка просто ничего не делает, а лента
         остаётся рабочей — попап это дополнение, а не единственный доступ. */
      if (!modal || typeof modal.show !== 'function') return;

      initLightbox(modal);
      showItem(modal, parseInt(button.getAttribute('data-shop-lightbox-open'), 10) || 0);
      modal.show(button);
    });
  }

  function init() {
    expireSpecialDates();
    Array.prototype.forEach.call(document.querySelectorAll('[data-shop-hours]'), initHours);
    Array.prototype.forEach.call(document.querySelectorAll('[data-shop-tabs]'), initTabs);
    Array.prototype.forEach.call(document.querySelectorAll('[data-shop-lightbox-open]'), initLightboxOpener);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.setInterval(tick, TICK_MS);
})();
